import {Utils} from "./Utils";

Utils.executeWhenDocumentIsReady( () => {
    const shareButtons = document.querySelectorAll<HTMLButtonElement>(
        ".o-teaser__share-button",
    )
    const shareCloseButtons = document.querySelectorAll<HTMLButtonElement>(
        ".o-teaser__share-close",
    )

    shareButtons.forEach((button: HTMLElement) => {
        button.addEventListener("click", () => {
            const shareOverlay = button.nextElementSibling
            if (shareOverlay) {
                shareOverlay.classList.add("is-visible")
            }
        })
    })

    shareCloseButtons.forEach((button: HTMLElement) => {
        button.addEventListener("click", () => {
            const shareOverlay = button.parentElement
            if (shareOverlay) {
                shareOverlay.classList.remove("is-visible")
            }
        })
    })
})
